import { HttpClient, HttpParams } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { catchError, map, Observable, throwError } from 'rxjs'
import {
  EmployeeSalary,
  EmployeeSalaryWithUser
} from '../store/employee-salary/employee-salary.state'
import { eps } from './url.service'

@Injectable({
  providedIn: 'root'
})
export class EmployeeSalaryService {
  private http = inject(HttpClient)
  private salaryApi = eps.hrm.createSalaryApi

  //Load All Salaries
  loadAllSalaries(employeeId: string, belongsTo: string | null): Observable<EmployeeSalary[]> {
    let params = new HttpParams()
    params = params.set('employeeId', employeeId)
    if (belongsTo) {
      params = params.set('belongsTo', belongsTo)
    }

    return this.http.get<EmployeeSalary[]>(`${this.salaryApi}/all`, { params }).pipe(
      map(response => response),
      catchError(error => throwError(() => error))
    )
  }

  //Load Latest Salary
  loadSalary(employeeId: string, belongsTo: string | null): Observable<EmployeeSalary> {
    let params = new HttpParams()
    params = params.set('employeeId', employeeId)
    if (belongsTo) {
      params = params.set('belongsTo', belongsTo)
    }

    return this.http.get<EmployeeSalary>(this.salaryApi, { params }).pipe(
      map(response => ({
        ...response,
        ctcValue:
          typeof response.ctcValue === 'string'
            ? Math.floor(parseFloat(response.ctcValue))
            : response.ctcValue
      })),
      catchError(error => throwError(() => error))
    )
  }

  //TODO: Create separate methods for create and revise salary (both fron and backend)
  addSalary(salary: EmployeeSalary): Observable<EmployeeSalary> {
    // Create payload to omit id, createdAt, updatedAt, deletedAt
    const payload: EmployeeSalary = {
      belongsTo: salary.belongsTo,
      employeeId: salary.employeeId,
      statutoryCompliances: salary.statutoryCompliances,
      ctcValue: salary.ctcValue,
      ctc: salary.ctc,
      salaryData: salary.salaryData,
      effectiveFrom: salary.ctc.effectiveFrom,
      payoutFrom: salary.ctc.payoutFrom
    }
    return this.http.post<EmployeeSalary>(this.salaryApi, payload).pipe(
      map(response => response),
      catchError(error => throwError(() => error))
    )
  }

  // kripesh
  // updateSalary(salary: EmployeeSalary): Observable<EmployeeSalary> {
  //   return this.http.put<EmployeeSalary>(`${this.salaryApi}`, { ...salary }).pipe(
  //     map(response => response),
  //     catchError(error => throwError(() => error))
  //   )
  // }

  //gps 7 january 2026
  updateSalary(salary: EmployeeSalary): Observable<EmployeeSalary> {
    // Clone salary to avoid mutation
    const payload: any = { ...salary }

    // Safely remove nested fields if they exist
    if (payload) {
      delete payload.baseSalary
      delete payload.salaryStructure
    }

    return this.http.put<EmployeeSalary>(this.salaryApi, payload).pipe(
      map(response => response),
      catchError(error => throwError(() => error))
    )
  }

  deleteSalary(id: string): Observable<{ message: string; status: string }> {
    return this.http
      .delete<{
        message: string
        status: string
      }>(`${this.salaryApi}/${id}`)
      .pipe(
        map(response => response),
        catchError(error => throwError(() => error))
      )
  }

  //Load All Latest Salaries by BusinessId
  loadLatestSalariesOfBusiness(belongsTo: string): Observable<EmployeeSalaryWithUser[]> {
    let params = new HttpParams()
    params = params.set('businessId', belongsTo)

    return this.http.get<EmployeeSalaryWithUser[]>(`${this.salaryApi}/business`, { params }).pipe(
      map(response => response),
      catchError(error => throwError(() => error))
    )
  }
}
